import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { SearchFilterAction } from '@cbridge-modules/search-filter';
import { serversFilterInitialState } from './serversFilter.constant';
import { ServersFilterAction } from './serversFilter.action';
import { IServersFilterStore } from './serversFilter.interface';

export const serversFilterReducer = reducerWithInitialState(serversFilterInitialState)
  .case(ServersFilterAction.select, (state, payload) => {
    const { serverId } = payload;

    return {
      ...state,
      selected: serverId,
    };
  })
  .case(ServersFilterAction.toggleSelect, (state, payload) => {
    const { serverId } = payload;
    if (state.selected === serverId) {
      return {
        ...state,
        selected: undefined,
      };
    }
    return {
      ...state,
      selected: serverId,
    };
  })
  .case(ServersFilterAction.clearSelect, (state) => {
    return {
      ...state,
      selected: undefined,
    };
  })
  .case(SearchFilterAction.destroy, (): IServersFilterStore => {
    return {
      ...serversFilterInitialState,
    };
  });
